import React, { useState } from 'react';
import { Canvas } from '@react-three/fiber';
import { Button } from './components/Button/button';
import Particles from './components/ParticleScene/particles';
import './styles/main.scss';

interface ParticleData {
  data: Uint8ClampedArray;
  w: number;
  h: number;
  targetBtn: HTMLButtonElement;
}

const App: React.FC = () => {
  const [particleData, setParticleData] = useState<ParticleData | null>(null);

  const handleExplode = (data: Uint8ClampedArray, w: number, h: number, targetBtn: HTMLButtonElement) => {
    setParticleData({ data, w, h, targetBtn });
  };

  const handleCleanUp = () => {
    setParticleData(null);
  };

  return (
    <main className="appMain">
      <div className="buttonHolder">
        <Button onExplode={handleExplode} />

        <div className="canvasWrapper" style={{ 
          pointerEvents: particleData ? 'all' : 'none', 
          zIndex: particleData ? 100 : 1
          }}>
          <Canvas
            gl={{ alpha: true, antialias: true }}
            camera={{ position: [0, 0, 150], fov: 45 }}
            style={{ background: 'transparent' }}
            dpr={[1, 2]}
          >

            {particleData && (
              <Particles
                data={particleData.data}
                width={particleData.w}
                height={particleData.h}
                onComplete={handleCleanUp}
                targetBtn={particleData.targetBtn}
              />
            )}
          </Canvas>
        </div>
      </div>
    </main>
  );
};

export default App;